import { PageContainer } from '../../components/PageContainer';
import { Typography } from '../../components/ui/Typography';

export const WineDetailLoading = () => {
  return (
    <div className="px-0 md:px-6 lg:px-8 pt-2 pb-4 max-w-4xl lg:max-w-5xl xl:max-w-6xl 2xl:max-w-7xl mx-auto">
      {/* Back link skeleton */}
      <div className="h-6 w-24 bg-gray-200 rounded animate-pulse mb-2"></div>
      
      <PageContainer className="space-y-4 md:space-y-6 lg:space-y-8 mt-2">
        {/* Wine Header Skeleton - Updated for new hierarchy */}
        <div className="border-b border-gray-200 pb-4 md:pb-6 lg:pb-8">
          <div className="lg:flex lg:items-start lg:justify-between lg:gap-8">
            <div className="lg:flex-1">
              {/* Winery name skeleton (H1) - Larger than wine name */}
              <div className="h-12 md:h-16 lg:h-20 xl:h-24 w-2/3 bg-gray-200 rounded animate-pulse mb-2 md:mb-3 lg:mb-4"></div>
              
              {/* Wine name skeleton (H2) - Smaller than winery name */}
              <div className="h-8 md:h-12 lg:h-16 xl:h-20 w-3/4 bg-gray-200 rounded animate-pulse mb-2 md:mb-3 lg:mb-4"></div>
              
              {/* Wine type skeleton (H3) - Smaller than wine name */}
              <div className="h-6 md:h-10 lg:h-12 xl:h-16 w-1/2 bg-gray-200 rounded animate-pulse mb-4 md:mb-6 lg:mb-8"></div>
              
              {/* Additional wine info skeleton */}
              <div className="space-y-2 md:space-y-3 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:gap-y-4 lg:space-y-0">
                <div className="flex items-center gap-2 md:gap-3 lg:gap-4">
                  <div className="h-4 md:h-5 lg:h-6 w-16 bg-gray-200 rounded animate-pulse"></div>
                  <div className="h-5 md:h-6 lg:h-7 w-12 bg-gray-200 rounded animate-pulse"></div>
                </div>
                <div className="flex items-center gap-2 md:gap-3 lg:gap-4">
                  <div className="h-4 md:h-5 lg:h-6 w-20 bg-gray-200 rounded animate-pulse"></div>
                  <div className="h-4 md:h-5 lg:h-6 w-16 bg-gray-200 rounded animate-pulse"></div>
                </div>
                <div className="flex items-center gap-2 md:gap-3 lg:gap-4">
                  <div className="h-4 md:h-5 lg:h-6 w-10 bg-gray-200 rounded animate-pulse"></div>
                  <div className="h-4 md:h-5 lg:h-6 w-20 bg-gray-200 rounded animate-pulse"></div>
                </div>
              </div>
            </div>
            
            {/* Hero image skeleton - 9:16 aspect ratio - Enhanced responsive */}
            <div className="mt-6 sm:mt-8 md:mt-6 lg:mt-0 lg:w-80 xl:w-96 2xl:w-[400px] flex-shrink-0">
              <div className="mx-auto max-w-[280px] sm:max-w-[320px] md:max-w-[360px] lg:max-w-none">
                <div className="aspect-[9/16] bg-gray-200 rounded-lg animate-pulse shadow-md"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Info Section Skeleton - Mobile optimized */}
        <div className="border-b border-gray-200 pb-4 md:pb-6">
          <div className="h-6 md:h-7 lg:h-8 w-24 bg-gray-200 rounded animate-pulse mb-4 sm:mb-5 md:mb-4 lg:mb-6"></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-6">
            {[1, 2, 3].map((i) => (
              <div key={i} className="bg-gray-50 rounded-lg p-4 sm:p-5 md:p-6">
                <div className="h-4 md:h-5 w-16 bg-gray-200 rounded animate-pulse mb-2"></div>
                <div className="h-6 md:h-7 w-20 bg-gray-200 rounded animate-pulse"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Description Section Skeleton */}
        <div className="border-b border-gray-200 pb-4 md:pb-6">
          <div className="h-6 md:h-7 lg:h-8 w-24 bg-gray-200 rounded animate-pulse mb-3 md:mb-4 lg:mb-6"></div>
          <div className="space-y-2">
            <div className="h-4 md:h-5 lg:h-6 w-full bg-gray-200 rounded animate-pulse"></div>
            <div className="h-4 md:h-5 lg:h-6 w-5/6 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-4 md:h-5 lg:h-6 w-4/5 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>

        {/* Additional Images Section Skeleton */}
        <div>
          <div className="h-6 md:h-7 lg:h-8 w-32 bg-gray-200 rounded animate-pulse mb-3 md:mb-4 lg:mb-6"></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-3 md:gap-4 lg:gap-6">
            {[1, 2, 3].map((i) => (
              <div key={i} className="aspect-square bg-gray-200 rounded-lg animate-pulse"></div>
            ))}
          </div>
        </div>

        {/* Loading indicator with spinner */}
        <div className="flex items-center justify-center py-8">
          <div className="flex items-center space-x-3">
            <div className="animate-spin rounded-full h-6 w-6 md:h-8 md:w-8 border-b-2 border-primary-600"></div>
            <Typography 
              variant="bodyMedium" 
              as="p" 
              className="text-gray-600"
            >
              Loading wine details...
            </Typography>
          </div>
        </div>
      </PageContainer>
    </div>
  );
};